import { INDICATOR, INDICATOR_PRODUCTS_BY_DOMAIN } from '@/api/rest/resources/types/IndicatorProduct';
import { useWorkstreams } from '@/hooks/useWorkstreams';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { useSelectedIndicatorProducts } from '@/pages/shared/indicators/hooks/useIndicatorProducts';

export const useDomainVisibility = (
  domains?: Record<string, (typeof INDICATOR)[keyof typeof INDICATOR][]>,
): {
  carbon: boolean;
  water: boolean;
  biodiversity: boolean;
  soil: boolean;
  social: boolean;
} => {
  const workstreams = useWorkstreams().data;
  const indicatorProducts = useSelectedIndicatorProducts();
  const workstreamId = useWorkstreamId();

  const domainMap = domains ?? INDICATOR_PRODUCTS_BY_DOMAIN;

  if (!workstreamId) {
    return {
      carbon: true,
      water: true,
      biodiversity: true,
      soil: true,
      social: true,
    };
  }

  const workstreamIndicatorProducts = (workstreams?.find((ws) => ws.id === workstreamId)?.indicator_products || [])
    ?.map((id) => indicatorProducts.find((ip) => ip.id === id)?.name)
    .filter(Boolean) as string[];

  const isDomainInWorkstream = (domain: keyof typeof domainMap) => {
    if (!workstreamId) return true;
    return domainMap[`${domain}`].some((indicator) => workstreamIndicatorProducts.includes(indicator));
  };

  return {
    carbon: isDomainInWorkstream('carbon'),
    water: isDomainInWorkstream('water'),
    biodiversity: isDomainInWorkstream('biodiversity'),
    soil: isDomainInWorkstream('soil'),
    social: isDomainInWorkstream('social'),
  };
};
